import {Component} from 'react';
import PropTypes from 'prop-types';

export class CookiesProvider extends Component {
  static contextTypes = {
    logger: PropTypes.object,
  };

  static childContextTypes = {
    cookies: PropTypes.object,
  };

  static propTypes = {
    instance: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.setLoggerOnInstance(props);
  }

  setLoggerOnInstance({instance}) {
    const {logger} = this.context;
    /* istanbul ignore else */
    if (instance) {
      instance.logger = logger;
    }
  }

  getChildContext() {
    const {instance} = this.props;

    return {
      cookies: instance,
    };
  }

  render() {
    const {children} = this.props;

    return children;
  }
}

export default CookiesProvider;
